import React from 'react'
import FormROValue from '../../../../../library/form/components/FormROValue1';
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdSearchGridProcessHeader = ({formObject, rowKey}) => {

    return (
        <FormWrapper customWrapper="div" formObject={formObject} rowKey={rowKey} action={{ paramName: "group" }}>
            <div className='uiXYGridXRowHeight uiXYTitle'>
                <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "group" }} className='uiBlock uiBlock100' />
            </div>
        </FormWrapper>
    );
}

export default ProdSearchGridProcessHeader
